export const setItem = (key: string, value: string) => {
  let val = value;
  if (key && val) {
    if (typeof val !== 'string') {
      val = JSON.stringify(val);
    }
    sessionStorage.setItem(key, val);
  }
};

export const setLocalItem = (key: string, value: string) => {
  let val = value;
  if (key && val) {
    if (typeof val !== 'string') {
      val = JSON.stringify(val);
    }
    localStorage.setItem(key, val);
  }
};

export const getItem = (key: string) => {
  let value;
  if (key) {
    value = sessionStorage.getItem(key);
    if (value === undefined || value === null) {
      return null;
    }
    value = value.toString().trim();
    value =
      value[0] === '{' && value[value.length - 1] === '}'
        ? JSON.parse(value)
        : value;
  }
  return value;
};

export const getLocalItem = (key: string) => {
  let value;
  if (key) {
    value = localStorage.getItem(key);
    if (value === undefined || value === null) {
      return null;
    }
    value = value.toString().trim();
    value =
      value[0] === '{' && value[value.length - 1] === '}'
        ? JSON.parse(value)
        : value;
  }
  return value;
};

export const removeItem = (key: string) => {
  if (key) {
    sessionStorage.removeItem(key);
  }
};

export const clearStorage = () => {
  sessionStorage.clear();
};
